// extracted by mini-css-extract-plugin
module.exports = {"email":"_2Cby1","password":"surBG"};